import M_optionItem from '@/models/optionItem';

export default {
  fields: {
    value_operator: {
      placeholder: '設定條件',
      items:[
        {
          value: 'lt',
          text: '小於 <'
        },
        {
          value: 'lte',
          text: '小於等於 ≦'
        },
        {
          value: 'gt',
          text: '大於 >'
        },
        {
          value: 'gte',
          text: '大於等於 ≧'
        },
        {
          value: 'eq',
          text: '等於 ='
        },
        {
          value: 'neq',
          text: '不等於 ≠'
        },
        {
          value: 'in',
          text: '介於'
        },
        {
          value: 'not_in',
          text: '不介於'
        },
      ],
    },
    limit_lower: {
      placeholder: '輸入數值',
    },
    limit_upper: {
      placeholder: '輸入數值',
    },
    risk_level: {
      ...M_optionItem.fields.optionItem.fields.risk_level,
    }
  }
}